module.exports = __webpack_public_path__ + "img/close.761610d8.svg";